import { useCallback, useEffect, useState, useRef } from 'react';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';

import { VerificaRota } from '../../../../../services/VerificaSePodeAcessar';
import { EmitirErro } from '../../../../../services/EmitirErro';
import { SairDoSistema } from '../../../../../services/LStorage/SairSistema';

import RecargasService from '../../../../../services/http/services/CongelamentoPorCNPJ/RecargasService';
import { formatCurrencyForPersistence, validaDigitaçãoEFormataDinheiroBR } from '../../../../../services/Conversores';

interface IProps { id?: string };

export const useCertidoesAddOrUpdate = ({ id }: IProps) => {

    const navigate = useNavigate();

    const refForm = useRef<any>(null);

    const refAbortController = useRef<AbortController>();

    const [estaEditando, setEstaEditando] = useState(false);

    const [loading, setLoading] = useState(false);

    useEffect(() => () => {
        refAbortController.current?.abort();
    }, []);

    const buscaDadosRecargaESetCampos = useCallback((id: string) => {
        const requestAsync = async () => {
            try {

                const response = await RecargasService.findById(id, refAbortController.current?.signal);

                if (response) {
                    refForm.current?.setFieldsValue(
                        {
                            valor: response.valor ? validaDigitaçãoEFormataDinheiroBR(String(response.valor * 100)) : undefined,
                        }
                    );
                }

            } catch (error) {
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoreditrecarga_dkwdfaiweyi')
                }
            }
        }

        requestAsync();
    }, []);

    useEffect(() => {

        let arrayUrl = window.location.pathname.split("/");
        VerificaRota(arrayUrl, navigate, true);

        if (typeof id === 'string') {
            if (id === 'criar') {
                setEstaEditando(false)
            } else {
                setEstaEditando(true)
                buscaDadosRecargaESetCampos(id);
            }
        }
    }, []);

    const submitBotaoSalvar = useCallback(() => {
        const salvarDadosCriar = async (obj: any) => {
            try {
                setLoading(true);

                await RecargasService.create(obj.valor, refAbortController.current?.signal);

                notification.success({
                    message: 'Sucesso',
                    description:
                        'Seus dados foram criados com sucesso!',
                });

                setLoading(false);

                navigate('/congelamento-cnpj/recargas')

            } catch (error) {
                setLoading(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoreditrecarga_dkwdfaiweyi')
                }
            }
        }

        refForm.current?.validateFields()
            .then((values: any) => {

                values.valor = formatCurrencyForPersistence(values.valor);

                salvarDadosCriar(values);

            })
            .catch((errorInfo: any) => {

                const fieldWithError = errorInfo.errorFields[0].name[0];
                refForm.current.getFieldInstance(fieldWithError).focus();

                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatórios!',
                });
            });


    }, []);

    const submitBotaoEditar = useCallback((id: string) => {
        const salvarDadosEditar = async (obj: any) => {
            try {
                setLoading(true);

                await RecargasService.update(id, obj.valor, refAbortController.current?.signal);

                notification.success({
                    message: 'Sucesso',
                    description:
                        'Seus dados foram editados com sucesso!',
                });

                setLoading(false);
                navigate('/congelamento-cnpj/recargas');

            } catch (error) {
                setLoading(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoreditrecarga_dkwdfaiweyi')
                }
            }
        }

        refForm.current?.validateFields()
            .then((values: any) => {
                values.valor = formatCurrencyForPersistence(values.valor);

                salvarDadosEditar(values);
            })
            .catch((errorInfo: any) => {
                const fieldWithError = errorInfo.errorFields[0].name[0];
                refForm.current.getFieldInstance(fieldWithError).focus();

                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatórios!',
                });
            });


    }, []);

    const onChangeInputFormatMoney = useCallback((e: any) => {
        refForm.current.setFieldsValue(
            { valor: validaDigitaçãoEFormataDinheiroBR(e.target.value) }
        );
    }, []);

    return {
        loading,
        estaEditando,
        navigate,
        refForm,
        submitBotaoEditar,
        submitBotaoSalvar,
        onChangeInputFormatMoney
    }
}
